// 业务页面路由配置
import { lazy } from "react";
import { IRoute } from "@src/Model/IRoute";
import { MobileProductRoutes } from "./ProductRoutes";
import { MobileIndustryRoutes } from "./IndustryRoutes";

const MobileRoutes: IRoute[] = [
    {
        path: "/:lang/home",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Home")),
    },
    {
        path: "/:lang/download-center/:app?",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Download")),
    },
    {
        path: "/:lang/company-introduce",
        Component: lazy(() => import("@src/Pages/CN/Mobile/CompanyIntroduce")),
    },
    {
        path: "/:lang/article-center",
        Component: lazy(() => import("@src/Pages/CN/Mobile/ArticleCenter")),
    },
    {
        path: "/:lang/article-center/detail/:id?",
        Component: lazy(() => import("@src/Pages/CN/Mobile/ArticleCenter/Detail")),
    },
    {
        path: "/:lang/protocol",
        Component: lazy(() => import("@src/Pages/CN/Mobile/ProtocolAndPrivacy/Protocol")),
    },
    {
        path: "/:lang/privacy",
        Component: lazy(() => import("@src/Pages/CN/Mobile/ProtocolAndPrivacy/Privacy")),
    },
    {
        path: "/:lang/cases",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Cases")),
    },
    {
        path: "/:lang/cases/detail/:id?",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Cases/Detail")),
    },
    ...MobileProductRoutes,
    ...MobileIndustryRoutes
];

export const MobileNoFrameworkRoutes = [
    // {
    //     path: "/protocol",
    //     Component: lazy(() => import("@src/Pages/CN/PC/ProtocolAndPrivacy/Protocol")),
    // },
    // {
    //     path: "/privacy",
    //     Component: lazy(() => import("@src/Pages/CN/PC/ProtocolAndPrivacy/Privacy")),
    // }
]


export default MobileRoutes;
